import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const PublishingControls = ({ 
  status, 
  onStatusChange, 
  author, 
  onAuthorChange,
  onSave,
  onPublish,
  onCancel,
  isSaving,
  lastSaved
}) => {
  const statusOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'published', label: 'Published' }
  ];

  const authorOptions = [
    { value: 'john-doe', label: 'John Doe' },
    { value: 'jane-smith', label: 'Jane Smith' },
    { value: 'alex-johnson', label: 'Alex Johnson' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 sticky top-24">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4 md:mb-6">
        Publishing Options
      </h3>

      <div className="space-y-4 md:space-y-6">
        <Select
          label="Status"
          options={statusOptions}
          value={status}
          onChange={onStatusChange}
        />

        <Select
          label="Author"
          options={authorOptions}
          value={author}
          onChange={onAuthorChange}
        />

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Last Saved</label>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Clock" size={16} color="currentColor" />
            <span>{lastSaved || 'Never'}</span>
          </div>
        </div>

        <div className="pt-4 border-t border-border space-y-3">
          <Button
            variant="default"
            iconName="Save"
            iconPosition="left"
            onClick={onSave}
            loading={isSaving}
            fullWidth
          >
            Save Draft
          </Button>

          <Button
            variant="success"
            iconName="Upload"
            iconPosition="left"
            onClick={onPublish}
            disabled={status !== 'published'}
            fullWidth
          >
            {status === 'published' ? 'Publish Post' : 'Set to Published First'}
          </Button>

          <Button
            variant="ghost"
            iconName="X"
            iconPosition="left"
            onClick={onCancel}
            fullWidth
          >
            Cancel
          </Button>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-start gap-2 p-3 bg-muted rounded-lg">
            <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground">
              Draft posts are only visible to admins. Published posts appear on the public blog.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublishingControls;